define.alias("shared/utils/string-formatters/camel-to-snake", "calendar/utils/string-formatters/camel-to-snake");